module.exports = __webpack_public_path__ + "img/youth-engaged.cd5704fd.png";